import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import { AuthEventIds } from '../../../EventIds.es.js';
import { createRandomString } from './utils.es.js';

// Code highly inspired from https://github.com/auth0/auth0-spa-js/blob/master/src/transaction-manager.ts

var TRANSACTION_STORAGE_KEY_PREFIX = 'landr.auth.txs';
var TransactionManager = /*#__PURE__*/function () {
  function TransactionManager(storage, clientId, log) {
    _classCallCheck(this, TransactionManager);
    this.storage = void 0;
    this.storageKey = void 0;
    this.log = void 0;
    this.storage = storage;
    this.storageKey = "".concat(TRANSACTION_STORAGE_KEY_PREFIX, ".").concat(clientId);
    this.log = log;
  }
  _createClass(TransactionManager, [{
    key: "create",
    value: function create(_ref) {
      var authState = _ref.authState,
        redirectUri = _ref.redirectUri,
        _ref$shouldStore = _ref.shouldStore,
        shouldStore = _ref$shouldStore === void 0 ? true : _ref$shouldStore;
      // Create transaction for later validation, and authState retrieval
      var codeVerifier = createRandomString();
      var state = btoa(createRandomString()); // Base64-encoded ASCII string from a binary string
      var transaction = {
        codeVerifier: codeVerifier,
        state: state,
        authState: authState,
        redirectUri: redirectUri
      };
      if (shouldStore) {
        this.store(transaction);
      }
      return transaction;
    }
  }, {
    key: "store",
    value: function store(transaction) {
      this.log.info("Storing transaction with key ".concat(this.storageKey), AuthEventIds.StoreTransactionInvoked);
      this.storage.save(this.storageKey, transaction, {
        daysUntilExpire: 1
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.storage.get(this.storageKey);
    }
  }]);
  return TransactionManager;
}();

export { TransactionManager };
